import React, { useState, useEffect, useRef } from "react";
import { Offcanvas, Tabs, Tab, Button, Form, Table, Dropdown, Modal } from "react-bootstrap";
import axios from "axios";
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import PurchaseOrderForm from '../purchaseorder/PurchaseOrderForm';
import moment from "moment";
import { FaRegClock, FaUserEdit, FaFileInvoice, FaTag } from "react-icons/fa";
import { useMemo } from 'react';
import QuotationPDF1 from "./QuotationPDF1";
import ProformaInvoicePDF from "../ProformaInvoice/ProformaInvoicePDF";
import { PDFViewer } from "@react-pdf/renderer";

import { pdf } from "@react-pdf/renderer";


const QuotationDetailsModal = ({
    showModal,
    handleCloseModal,
    quotationId,
    projectId
}) => {
    const [activeTab, setActiveTab] = useState("proformaInvoice");
    const [quotationDetails, setQuotationDetails] = useState(null);
    const [proformaInvoices, setProformaInvoices] = useState([]);
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [taxInvoices, setTaxInvoices] = useState([]);
    const [quotationHistory, setQuotationHistory] = useState([]);
    const [statusUpdateData, setStatusUpdateData] = useState({
        description: "",
        file: null,
    });
    const [isQuotationModalVisible, setIsQuotationModalVisible] = useState(showModal);
    const [showPreview, setShowPreview] = useState(false);
    const [previewType, setPreviewType] = useState(null);
    const [previewData, setPreviewData] = useState(null);

    const handlePreview = async (type, data) => {
        if (type === "quotation") {
            const blob = await pdf(
                <QuotationPDF1
                    quotation={data.quotation}
                    quotationNotes={data.quotationNotes}
                    quotationTerms={data.quotationTerms}
                    companyDetails={data.companyDetails}
                />
            ).toBlob();

            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
        }

        setPreviewType(type);
        setPreviewData(data);
        setShowPreview(true);
    };


    const [pdfUrl, setPdfUrl] = useState(null);

    const [dropdownVisible, setDropdownVisible] = useState(null);
    const [selectedProformaInvoiceId, setSelectedProformaInvoiceId] = useState(null);
    const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState(null);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [nextStatus, setNextStatus] = useState("");
    const [type, setType] = useState(""); // "proforma" or "purchase"
    const dropdownRefs = useRef({});
    const [isLoading, setIsLoading] = useState(false);
    const [showPurchaseOrderModal, setShowPurchaseOrderModal] = useState(false);
    const [poId, setPoId] = useState(null);
    const [selectedVendorId, setSelectedVendorId] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    useEffect(() => {
        if (quotationId && showModal) {
            setIsLoading(true);  // Start loader before fetching
            fetchQuotationDetails().then(() => setIsLoading(false));
            fetchQuotationHistory().then(() => setIsLoading(false));
        }
    }, [quotationId, showModal]);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    function formatAction(action) {
        if (!action) return '';
        return action
            .split('_') // Split by underscore
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
            .join(' '); // Join back with a space
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString(); // This will return the date in the format "MM/DD/YYYY"
    };


    const fetchQuotationDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true
            });

            setQuotationDetails(response.data.quotation);
            setProformaInvoices(response.data.quotation.proforma_invoices || []);
            setPurchaseOrders(response.data.quotation.purchase_order || []);
            setTaxInvoices(response.data.quotation?.proforma_invoices?.map(pi => pi.tax_invoice).filter(ti => ti) || []);
        } catch (error) {
            console.error("Error fetching quotation details:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to fetch quotation details.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        }
    };

    const fetchQuotationHistory = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/projects/${projectId}/quotations/${quotationId}/quotation-history`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, 'Tenant-Origin': origin,
                    },
                    skipLoader: true
                }
            );

            setQuotationHistory(response.data.data || []);
            // const formattedHistory = (response.data.data || []).map(item => ({
            //     ...item,
            //     formattedAction: formatAction(item.action), // Ensure action is formatted
            // }));

            // setQuotationHistory(formattedHistory);


        } catch (error) {
            console.error("Error fetching quotation history:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to fetch quotation history.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        }
    };
    const getIcon = (action) => {
        switch (action) {
            case "Quotation Created":
                return <FaRegClock className="icon created" />;

            default:
                return <FaRegClock className="icon default" />;
        }
    };
    const handleStatusUpdate = async () => {
        try {
            setIsLoading(true);
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const formData = new FormData();
            formData.append("description", statusUpdateData.description);
            if (statusUpdateData.file) {
                formData.append("file", statusUpdateData.file);
            }

            const url =
                type === "proforma"
                    ? `${backendUrl}/api/proformainvoice/${selectedProformaInvoiceId}/pistatus`
                    : `${backendUrl}/api/purchaseorder/${selectedPurchaseOrderId}/postatus`;

            await axios.post(url, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                    'Tenant-Origin': origin,

                },
            });

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `Status updated successfully for ${type === "proforma" ? "Proforma Invoice" : "Purchase Order"}`,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            setStatusUpdateData({ description: "", file: null }); // Clear the file field
            setShowStatusModal(false);
            fetchQuotationDetails(); // Refresh data
        } catch (error) {
            console.error("Error updating status:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to update status.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
        } finally {
            setIsLoading(false); // Hide loader
        }
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];

        setStatusUpdateData({ ...statusUpdateData, file });
    };



    const getNextStatus = (currentStatus, type) => {
        const statusMap = {
            proforma: {
                PI_generated: "PI_submited",
                PI_submited: "payment_received",
                payment_received: "",
            },
            purchase: {
                vendor_PO_generated: "vendor_payment_released",
                vendor_payment_released: "",
            },
        };
        return statusMap[type][currentStatus];
    };

    const handleOutsideClick = (event) => {
        if (
            dropdownVisible &&
            dropdownRefs.current[dropdownVisible] &&
            !dropdownRefs.current[dropdownVisible].contains(event.target)
        ) {
            setDropdownVisible(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [dropdownVisible]);
    const capitalizeWords = (str) => {
        return str?.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const deletePurchaseOrder = async (id) => {
        setIsQuotationModalVisible(false); // Hide Quotation modal
        setShowDeleteConfirmation(true);
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            setShowDeleteConfirmation(false);
            if (result.isConfirmed) {
                try {
                    setIsLoading(true);

                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    // Delete the purchase order from the backend
                    await axios.delete(`${backendUrl}/api/purchase-order/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },
                    });

                    setPurchaseOrders(prevOrders => {
                        if (Array.isArray(prevOrders)) {
                            return prevOrders?.filter(order => order.id !== id);
                        } else {
                            console.error('Expected an array for prevInvoices but received:', prevOrders);
                            return [];
                        }
                    });
                    await Swal.fire({
                        title: "Deleted!",
                        text: "The purchase order has been deleted.",
                        icon: "success",
                        willClose: () => {
                            // Re-open Quotation modal after the success message is dismissed
                            setIsQuotationModalVisible(true);
                        }
                    });
                } catch (error) {
                    console.error('Error deleting purchase order:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete purchase order. Please try again.",
                        "error"
                    );
                } finally {
                    setIsLoading(false); // Hide loader
                }
            } else {
                setIsQuotationModalVisible(true); // Re-open Quotation modal if delete is canceled
            }
        });

    };
    const deletePerformaInvoice = async (id) => {
        setIsQuotationModalVisible(false); // Hide Quotation modal
        setShowDeleteConfirmation(true);
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    setIsLoading(true);

                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/proformainvoice/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,

                        },
                    });


                    setProformaInvoices((prevInvoices) => {
                        if (!Array.isArray(prevInvoices)) return []; // Safety check

                        return prevInvoices.filter(invoice => invoice.id !== id)
                            .map(invoice => ({
                                ...invoice,
                                taxInvoice: invoice.taxInvoice?.pi_id === id ? null : invoice.taxInvoice
                            }));
                    });
                    setTaxInvoices((prevTaxInvoices) => {
                        if (!Array.isArray(prevTaxInvoices)) return [];
                        return prevTaxInvoices.filter(taxInvoice => taxInvoice.pi_id !== id);
                    });

                    await Swal.fire({
                        title: "Deleted!",
                        text: "The proforma invoice has been deleted.",
                        icon: "success",
                        willClose: () => {
                            // Re-open Quotation modal after the success message is dismissed
                            setIsQuotationModalVisible(true);
                        }
                    });
                } catch (error) {
                    console.error('Error deleting proforma invoice:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete proforma invoice. Please try again.",
                        "error"
                    );
                } finally {
                    setIsLoading(false); // Hide loader
                }
            } else {
                setIsQuotationModalVisible(true); // Re-open Quotation modal if delete is canceled
            }
        });

    };

    const handleEditClick = (quotation, purchaseOrderId) => {
        // Find the specific purchase order by its ID
        const selectedPO = quotation.purchase_order.find(po => po.id === purchaseOrderId);

        if (!selectedPO) {
            console.error("Purchase Order not found");
            return; // Exit if the purchase order is not found
        }

        // Create the updated purchase order data
        const updatedPurchaseOrder = {
            ...selectedPO, // Include the specific purchase order details
            product_item_details: selectedPO.product_item_details || [], // Ensure product details are included
        };

        setPurchaseOrders(updatedPurchaseOrder);
        setPoId(purchaseOrderId);
        setShowPurchaseOrderModal(true);

        console.log("Updated Purchase Order:", updatedPurchaseOrder);
    };



    const handleClosePurchaseOrderModal = () => {
        setShowPurchaseOrderModal(false); // Close PO modal
    };

    // const groupedUpdates = quotationHistory.reduce((acc, quotation) => {
    //     quotation.history.forEach((historyItem) => {
    //         const date = formatDate(quotation.date); // Ensure formatted date
    //         if (!acc[date]) {
    //             acc[date] = [];
    //         }
    //         acc[date].push(historyItem);
    //     });
    //     return acc;
    // }, {});

    const groupedUpdates = useMemo(() => {
        const grouped = quotationHistory.reduce((acc, quotation) => {
            quotation.history.forEach((historyItem) => {
                const date = formatDate(historyItem.created_at); // Group by actual update date
                if (!acc[date]) {
                    acc[date] = [];
                }
                acc[date].push(historyItem);
            });
            return acc;
        }, {});

        // Sort dates descending (latest first)
        return Object.fromEntries(
            Object.entries(grouped).sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
        );
    }, [quotationHistory]);


    useEffect(() => {
        setIsQuotationModalVisible(showModal);
    }, [showModal]);

    const handleOpenStatusModal = () => {
        setIsQuotationModalVisible(false); // Hide Quotation modal
        setShowStatusModal(true); // Show Status modal
    };

    const handleCloseStatusModal = () => {
        setShowStatusModal(false); // Close Status modal
        setTimeout(() => setIsQuotationModalVisible(true), 300); // Show Quotation modal after delay
    }; return (
        <>
            <Offcanvas
                show={showModal && !isLoading && isQuotationModalVisible && !showStatusModal && !showPreview}
                onHide={handleCloseModal}
                placement="end"
                style={{ width: '1050px' }}
            >
                <Offcanvas.Header closeButton className="bg-light">
                    <Offcanvas.Title className="h5">Quotation Details</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(key) => setActiveTab(key)}
                        id="quotation-details-tabs"
                        className="mb-3"
                    >
                        {/* Proforma Invoice Tab */}
                        <Tab eventKey="proformaInvoice" title="Proforma Invoice"><br />
                            <h4 className="mb-4 font-size-16">Proforma Invoices</h4><br />
                            <Table striped bordered hover className="view-table font-size-13">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Reference No</th>
                                        <th>Adv Amount</th>
                                        <th>Rcd Amount</th>
                                        <th>Total RcdAmount</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {proformaInvoices.length > 0 ? (
                                        proformaInvoices.map((invoice, index) => {
                                            const nextStatus = getNextStatus(invoice.pi_status, "proforma");
                                            const isVisible = dropdownVisible === `pi-${invoice.id}`;

                                            return (
                                                <tr key={invoice.id}>
                                                    <td>{index + 1}</td>
                                                    <td> <Link to={`/proformainvoice/details/${invoice.id}`} className="dropdown-item">{invoice.ref_no}</Link></td>
                                                    <td>{invoice.advanced_amount}%</td>
                                                    <td>{invoice.amount}</td>
                                                    <td>{invoice.total_amount_received}</td>

                                                    <td className="font-size-13">
                                                        <Dropdown ref={(el) => (dropdownRefs.current[`pi-${invoice.id}`] = el)}>
                                                            <Dropdown.Toggle variant="#dee2e6" id="dropdown-status" className="font-size-13">
                                                                {capitalizeWords(invoice.pi_status)}
                                                            </Dropdown.Toggle>
                                                            {nextStatus && (
                                                                <Dropdown.Menu show={isVisible}>
                                                                    <Dropdown.Item
                                                                        className="font-size-13"
                                                                        onClick={() => {
                                                                            setSelectedProformaInvoiceId(invoice.id);
                                                                            setNextStatus(nextStatus);
                                                                            setType("proforma");
                                                                            setShowStatusModal(true);
                                                                            setDropdownVisible(null);
                                                                        }}
                                                                    >
                                                                        {capitalizeWords(nextStatus)}
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            )}
                                                        </Dropdown>
                                                    </td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <i
                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                style={{ cursor: 'pointer' }}
                                                            ></i>
                                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                <li>
                                                                    <Link to={`/proformainvoice/details/${invoice.id}`} className="dropdown-item">
                                                                        View Details
                                                                    </Link>
                                                                </li>

                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => deletePerformaInvoice(invoice.id)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted">
                                                No proforma invoices available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Tab>

                        {/* Purchase Order Tab */}
                        <Tab eventKey="purchaseOrder" title="Purchase Order"><br />
                            <h4 className="mb-4 font-size-16">Purchase Orders</h4><br />
                            <Table striped bordered hover className="view-table font-size-13">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Reference No</th>
                                        <th>Vendor</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {purchaseOrders.length > 0 ? (
                                        purchaseOrders.map((order, index) => {
                                            const nextStatus = getNextStatus(order.po_status, "purchase");
                                            const isVisible = dropdownVisible === `po-${order.id}`;

                                            return (
                                                <tr key={order.id}>
                                                    <td>{index + 1}</td>
                                                    <td><Link to={`/purchase-order/details/${order.id}`} className="dropdown-item">{order.ref_no}</Link></td>
                                                    <td>
                                                        {
                                                            order.vendor ? order.vendor.name : " "
                                                        }
                                                    </td>


                                                    <td>{order.amount}</td>
                                                    <td>
                                                        <Dropdown ref={(el) => (dropdownRefs.current[`po-${order.id}`] = el)}>
                                                            <Dropdown.Toggle variant="#dee2e6" id="dropdown-status" className="font-size-13">
                                                                {capitalizeWords(order.po_status)}
                                                            </Dropdown.Toggle>
                                                            {nextStatus && (
                                                                <Dropdown.Menu show={isVisible}>
                                                                    <Dropdown.Item
                                                                        className="font-size-13"
                                                                        onClick={() => {
                                                                            setSelectedPurchaseOrderId(order.id);
                                                                            setNextStatus(nextStatus);
                                                                            setType("purchase");
                                                                            setShowStatusModal(true);
                                                                            setDropdownVisible(null);
                                                                        }}
                                                                    >
                                                                        {capitalizeWords(nextStatus)}
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            )}
                                                        </Dropdown>
                                                    </td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <i
                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                style={{ cursor: 'pointer' }}
                                                            ></i>
                                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                <li>
                                                                    <Link to={`/purchase-order/details/${order.id}`} className="dropdown-item">
                                                                        View Details
                                                                    </Link>
                                                                </li>
                                                                {/* <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => handleEditClick(quotationDetails, order.id)}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </li> */}
                                                                <li>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() => deletePurchaseOrder(order.id)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center text-muted">
                                                No purchase orders available.
                                            </td>
                                        </tr>
                                    )}
                                    {console.log("quotationDetails in Render:", quotationDetails)}

                                </tbody>
                            </Table>
                        </Tab>

                        {/* Tax Invoice Tab */}
                        <Tab eventKey="taxInvoice" title="Tax Invoice"><br />
                            <h4 className="mb-4">Tax Invoices</h4><br />
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Reference No</th>
                                        <th>Total Amount</th>
                                        <th>VAT amount</th>
                                        <th>VAT Inc Amount</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {taxInvoices.length > 0 ? (
                                        taxInvoices.map((invoice, index) => (
                                            <tr key={invoice.id}>
                                                <td>{index + 1}</td>
                                                <td><Link to={`/tax-invoice/details/${invoice.id}`} className="dropdown-item">{invoice.ref_no}</Link></td>
                                                <td>{invoice.amount_received}</td>
                                                <td>{invoice.vat_amount}</td>
                                                <td>{invoice.total_with_vat}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center text-muted">
                                                No tax invoices available.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Tab>

                        <Tab eventKey="quotationHistory" title="Timeline">
                            <br />
                            <h5 className="mb-4">Timeline</h5>
                            <br />

                            <div className="timeline">
                                {Object.entries(groupedUpdates)
                                    .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA)) // Sort by latest date first
                                    .map(([date, updates]) => (
                                        <div key={date} className="timeline-date-group">
                                            <div className="timeline-date-box">{date}</div>

                                            {updates
                                                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort updates by latest first
                                                .map((update, idx) => {
                                                    console.log("Timeline update:", update);

                                                    return (
                                                        <div key={`${date}-${idx}`} className="timeline-item">
                                                            <div className="timeline-time">
                                                                {moment(update.created_at).format("h:mm A")}
                                                            </div>
                                                            <div className="timeline-icon">{getIcon(update.action)}</div>
                                                            <div className="timeline-line"></div>

                                                            <div className="timeline-content">
                                                                <h6 className="timeline-title">
                                                                    {capitalizeWords(update.action || "")}

                                                                    {["Quotation", "proforma_invoice", "purchase_order", "tax_invoice"].includes(update.type) && (
                                                                        <>
                                                                            {/* {update.type === 'Quotation' && (
                                                                            <Link to={`/quotation/details/${update.quotation_id}`} className="timeline-link"> - view</Link>
                                                                        )}
                                                                        {update.type === 'proforma_invoice' && update.proforma_invoice_id && (
                                                                            <Link to={`/proformainvoice/details/${update.proforma_invoice_id}`} className="timeline-link"> - view</Link>
                                                                        )}
                                                                        {update.type === 'purchase_order' && update.purchase_order_id && (
                                                                            <Link to={`/purchase-order/details/${update.purchase_order_id}`} className="timeline-link"> - view</Link>
                                                                        )}
                                                                        {update.type === 'tax_invoice' && update?.tax_invoice_id && (
                                                                            <Link to={`/tax-invoice/details/${update.tax_invoice_id}`} className="timeline-link"> - view</Link>
                                                                        )} */}
                                                                            {/* {update.type === 'Quotation' && (
                                                                                <span
                                                                                    className="timeline-link"
                                                                                    onClick={() =>
                                                                                        handlePreview("quotation", {
                                                                                            quotation: update.quotation,
                                                                                            quotationNotes: update.quotation_notes,
                                                                                            quotationTerms: update.quotation_terms,
                                                                                            companyDetails: update.company_details
                                                                                        })
                                                                                    }
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    - view
                                                                                </span>
                                                                            )} */}
                                                                            {update.type === 'Quotation' && (
                                                                                <span
                                                                                    className="timeline-link"
                                                                                    onClick={async () => {
                                                                                        try {
                                                                                            const backendUrl = process.env.REACT_APP_BACKEND_URL;
                                                                                            const userInfo = JSON.parse(localStorage.getItem("user-info"));
                                                                                            const origin = localStorage.getItem("user-origin");
                                                                                            const token = userInfo?.token;

                                                                                            // fetch quotation details from backend
                                                                                            const res = await axios.get(`${backendUrl}/api/quotations/${update.quotation_id}`, {
                                                                                                headers: {
                                                                                                    Authorization: `Bearer ${token}`,
                                                                                                    "Tenant-Origin": origin,
                                                                                                },
                                                                                                skipLoader: true
                                                                                            });

                                                                                            // fetch company details as well
                                                                                            const companyRes = await axios.get(`${backendUrl}/api/settings`, {
                                                                                                headers: {
                                                                                                    Authorization: `Bearer ${token}`,
                                                                                                    "Tenant-Origin": origin,
                                                                                                },
                                                                                                skipLoader: true
                                                                                            });

                                                                                            const data = res.data.quotation;
                                                                                            const companyDetails = companyRes.data.setting;

                                                                                            handlePreview("quotation", {
                                                                                                quotation: data,
                                                                                                quotationNotes: data.notes,
                                                                                                quotationTerms: data.terms,
                                                                                                companyDetails: companyDetails,
                                                                                            });
                                                                                        } catch (error) {
                                                                                            console.error("Error fetching quotation details:", error);
                                                                                        }
                                                                                    }}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    - view
                                                                                </span>
                                                                            )}


                                                                            {update.type === 'proforma_invoice' && update.proforma_invoice_id && (
                                                                                <span
                                                                                    className="timeline-link"
                                                                                    onClick={() => handlePreview(`/proformainvoice/details/${update.proforma_invoice_id}`)}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    - view
                                                                                </span>
                                                                            )}

                                                                            {update.type === 'purchase_order' && update.purchase_order_id && (
                                                                                <span
                                                                                    className="timeline-link"
                                                                                    onClick={() => handlePreview(`/purchase-order/details/${update.purchase_order_id}`)}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    - view
                                                                                </span>
                                                                            )}

                                                                            {update.type === 'tax_invoice' && update.tax_invoice_id && (
                                                                                <span
                                                                                    className="timeline-link"
                                                                                    onClick={() => handlePreview(`/tax-invoice/details/${update.tax_invoice_id}`)}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    - view
                                                                                </span>
                                                                            )}

                                                                        </>
                                                                    )}
                                                                </h6>

                                                                {["quotation_status", "proforma_status", "purchase_order_status"].includes(update.type) && (
                                                                    <div className="timeline-status-content">
                                                                        <p className="timeline-details">
                                                                            {update.description || ""}

                                                                            {update.attatchment && update.attatchment.trim() !== "" && (
                                                                                <a
                                                                                    href={`${backendUrl}/storage/${update.attatchment}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    className="timeline-attachment"
                                                                                >
                                                                                    -Attachment
                                                                                </a>
                                                                            )}

                                                                        </p>
                                                                        {update.action === 'Assign to Project Team' && update.assigned_contacts && update.assigned_contacts.length > 0 && (
                                                                            <div className="assigned-contacts">
                                                                                <p><strong>Assigned Contacts:</strong></p>
                                                                                <ul>
                                                                                    {update.assigned_contacts.map(contact => (
                                                                                        <li key={contact.id}>{contact.name} ({contact.email})</li>
                                                                                    ))}
                                                                                </ul>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                <p className="timeline-byline">
                                                                    <small>by {update.created_by} {moment(update.created_at).format("MMM DD, YYYY")}</small>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    ))}
                            </div>
                        </Tab>


                    </Tabs>

                    {/* Status Update Modal */}

                </Offcanvas.Body>
                <PurchaseOrderForm
                    showModal={showPurchaseOrderModal}
                    purchaseorderData={purchaseOrders}
                    poId={poId}
                    products={selectedProducts}
                    vendorId={selectedVendorId}
                    handleClose={handleClosePurchaseOrderModal}
                    projectId={projectId}
                    quotationId={quotationId}
                    setPurchaseOrders={setPurchaseOrders}

                />

            </Offcanvas>
            <Offcanvas show={showPreview} onHide={() => setShowPreview(false)} placement="end" size="xl">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Preview</Offcanvas.Title>
                    {previewType && pdfUrl && (
                        <Button
                            variant="outline-primary"
                            className="ms-auto"
                            onClick={() => {
                                const link = document.createElement("a");
                                link.href = pdfUrl;
                                link.download = `${previewType}.pdf`;
                                link.click();
                            }}
                        >
                            Download
                        </Button>
                    )}
                </Offcanvas.Header>
                <Offcanvas.Body >
                     <div style={{ textAlign: "center", position: "relative", marginBottom: "1rem" }}>
                    {previewType === "quotation" && pdfUrl && (
                        <iframe
                            src={pdfUrl}
                            style={{ width: "100%", height: "300px", border: "none" }}
                            title="PDF Preview"
                        />
                    )}
                    {/* {previewType === "proforma" && previewData && (
                        <ProformaPDF1
                            proforma={previewData.proforma}
                            companyDetails={previewData.companyDetails}
                        />
                    )}

                    {previewType === "purchase_order" && previewData && (
                        <PurchaseOrderPDF1
                            purchaseOrder={previewData.purchaseOrder}
                            companyDetails={previewData.companyDetails}
                        />
                    )} */}
                    </div>
                </Offcanvas.Body>
            </Offcanvas>


            <Offcanvas show={showStatusModal} onHide={() => setShowStatusModal(false)} placement="end" style={{ width: "480px" }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Update Status</Offcanvas.Title>
                </Offcanvas.Header>
                <hr style={{ margin: 0 }} /><br />

                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={statusUpdateData.description}
                                name='description'
                                onChange={(e) =>
                                    setStatusUpdateData({ ...statusUpdateData, description: e.target.value })
                                }
                            />
                        </Form.Group><br />
                        <Form.Group className="mb-5">
                            <Form.Label>Upload File</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileChange}
                            />
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="p-3 d-flex justify-content-end border-top">
                    <Button variant="primary" onClick={handleStatusUpdate}>
                        Update
                    </Button>
                    <Button
                        variant="secondary"
                        className="ms-2"
                        onClick={() => setShowStatusModal(false)}
                    >
                        Cancel
                    </Button>
                </div>

            </Offcanvas>
        </>
    );
};

export default QuotationDetailsModal;